import * as moment from 'moment';

export class PortalInvite {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.portalID = json && json.portal_id || null;
        this.inviterAppUserID = json && json.inviter_app_user_id || null;
        this.email = json && json.email || null;
        this.token = json && json.token || null;
        this.dateSent = json && json.date_sent || null;
        this.dateAccepted = json && json.date_accepted || null;
        this.portalName = json && json.portal_name || null;
        this.inviterProfileImage = json && json.inviter_profile_image || null;
        this.appUserFirstName = json && json.app_user_first_name || null;
        this.appUserLastName = json && json.app_user_last_name || null;
        this.isRinknetStaff = json && json.is_rinknet_staff || null;
        this.hasParentAccess = json && json.has_parent_access || null;
        this.portalRoleID = json && json.portal_role_id || null;

        if(this.dateSent) {
            this.momentDateSent = moment(this.dateSent);
        }

        if(this.dateAccepted) {
            this.momentDateAccepted = moment(this.dateAccepted);
        }

        this.accepted = null;
        if(json && (json.accepted || json.accepted == false)) {
            this.accepted = json.accepted;
        } 
    }

    id: number;
    portalID: number;
    inviterAppUserID: number;
    email: string;
    token: string;
    dateSent: string;
    dateAccepted: string;
    portalName: string;
    accepted: boolean;
    inviterProfileImage: string;
    appUserFirstName: string;
    appUserLastName: string;
    portalRoleID: number;
    isStaff: boolean;
    memberExists: boolean;
    isRinknetStaff: boolean;
    hasParentAccess: boolean;

    momentDateSent: moment.Moment;
    momentDateAccepted: moment.Moment;
}